import Tooltip from '@/molecules/modals/Tooltip/Tooltip';
import Size from '@enums/Size';
import MuiIconButton from '@mui/material/IconButton';
import ButtonColors from './colors/ButtonColors';
import IconButtonSize from './utils/IconButtonSize';

const IconButton = ({
  children,
  color = 'secondary',
  disabled,
  label,
  labelPosition = 'right',
  tooltipColor = 'tertiary',
  onClick,
  size = Size.MEDIUM,
}) => {
  const sizeProps = IconButtonSize[size];

  return (
    <Tooltip title={label} color={tooltipColor} position={labelPosition}>
      <MuiIconButton
        // The tooltip is a hover affordance; the label is also this button's
        // only accessible name, since the icon carries no text.
        aria-label={typeof label === 'string' ? label : undefined}
        disabled={disabled}
        onClick={onClick}
        sx={{
          p: 0.5,
          ...ButtonColors[color].text.normal,
          '& .MuiSvgIcon-root': {
            fontSize: sizeProps.fontSize,
          },
        }}
      >
        {children}
      </MuiIconButton>
    </Tooltip>
  );
};

export default IconButton;
